<template>
  <div class="appinfo-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row justify="center">
      <v-col cols="12" :md="10" :lg="9">
        <v-card class="appinfo-card animated animate__bounceIn elevation-0">
          <div class="appinfo-header">
            <div class="appinfo-header__title">
              <v-icon small class="mr-2">mdi-application-cog</v-icon>
              Konfigurasi Informasi Aplikasi
            </div>
            <v-btn
              text
              small
              class="appinfo-header__save"
              :loading="saving"
              @click="fetchUpdate"
            >
              <v-icon left small>mdi-content-save</v-icon>
              Simpan
            </v-btn>
          </div>

          <v-card-text class="pa-0">
            <!-- Branding / Assets -->
            <div class="asset-preview">
              <div
                class="asset-background"
                :style="bgStyle"
              >
                <div class="asset-background__overlay"></div>
                <div class="asset-background__actions">
                  <v-btn
                    small
                    outlined
                    class="asset-btn"
                    @click="editBackground"
                  >
                    <v-icon left small>mdi-image</v-icon>
                    Background
                  </v-btn>
                </div>

                <div class="asset-content">
                  <div class="asset-logo" @click="uploadFoto">
                    <v-img
                      :src="foto"
                      contain
                      max-height="96"
                      max-width="96"
                      class="asset-logo__img"
                    >
                      <template v-slot:placeholder>
                        <div class="d-flex align-center justify-center fill-height">
                          <v-icon large color="#8fd6b5">mdi-image-outline</v-icon>
                        </div>
                      </template>
                    </v-img>
                    <div class="asset-logo__hint">
                      <v-icon small>mdi-camera</v-icon>
                      <span>Logo</span>
                    </div>
                  </div>

                  <div class="asset-meta">
                    <div class="asset-meta__name">
                      {{ record.app_name || 'Nama Aplikasi' }}
                    </div>
                    <div class="asset-meta__sub">
                      {{ record.app_slogan || 'Slogan aplikasi' }}
                      <span v-if="record.app_ver"> · v{{ record.app_ver }}</span>
                    </div>
                  </div>

                  <div class="asset-nav" @click="editSidebar">
                    <div class="asset-nav__panel">
                      <div class="asset-nav__brand-mark">S</div>
                      <div class="asset-nav__lines">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div class="asset-nav__hint">
                      <v-icon x-small>mdi-camera</v-icon>
                      Sidebar
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div :class="device.desktop ? 'pa-6' : 'pa-4'">
              <!-- Identitas Aplikasi -->
              <div class="section-header mb-4">
                <v-icon color="#1f7a57" class="mr-2" small>mdi-information-outline</v-icon>
                <span class="section-header__text">Identitas Aplikasi</span>
              </div>

              <v-row dense>
                <v-col cols="12" md="8">
                  <v-text-field
                    label="Nama Aplikasi"
                    color="#1f7a57"
                    v-model="record.app_name"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-application"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Versi"
                    color="#1f7a57"
                    v-model="record.app_ver"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-tag-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Keterangan"
                    color="#1f7a57"
                    v-model="record.app_desc"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-text"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Slogan"
                    color="#1f7a57"
                    v-model="record.app_slogan"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-format-quote-close"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="URL Aplikasi"
                    color="#1f7a57"
                    v-model="record.app_url"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-link-variant"
                    placeholder="https://"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-divider class="appinfo-divider my-6"></v-divider>

              <!-- Tampilan -->
              <div class="section-header mb-4">
                <v-icon color="#1f7a57" class="mr-2" small>mdi-palette-outline</v-icon>
                <span class="section-header__text">Tampilan</span>
              </div>

              <v-row dense>
                <v-col cols="12" md="6">
                  <v-select
                    label="Tema"
                    color="#1f7a57"
                    item-color="#1f7a57"
                    v-model="record.app_theme"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    :items="themes"
                    prepend-inner-icon="mdi-theme-light-dark"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="Warna"
                    color="#1f7a57"
                    item-color="#1f7a57"
                    v-model="record.app_color"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    :items="colors"
                    prepend-inner-icon="mdi-palette"
                  >
                    <template v-slot:selection="{ item }">
                      <div class="d-flex align-center">
                        <span
                          class="color-swatch mr-2"
                          :class="item.value"
                        ></span>
                        {{ item.text }}
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <div class="d-flex align-center">
                        <span
                          class="color-swatch mr-3"
                          :class="item.value"
                        ></span>
                        {{ item.text }}
                      </div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-divider class="appinfo-divider my-6"></v-divider>

              <!-- Instansi & Kontak -->
              <div class="section-header mb-4">
                <v-icon color="#1f7a57" class="mr-2" small>mdi-office-building-outline</v-icon>
                <span class="section-header__text">Instansi & Kontak</span>
              </div>

              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Nama Instansi"
                    color="#1f7a57"
                    v-model="record.app_company"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-domain"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Telepon / WhatsApp"
                    color="#1f7a57"
                    v-model="record.app_wa"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-whatsapp"
                    placeholder="628xxxxxxxxxx"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Alamat"
                    v-model="record.app_address"
                    color="#1f7a57"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    rows="3"
                    auto-grow
                    prepend-inner-icon="mdi-map-marker-outline"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-divider class="appinfo-divider my-6"></v-divider>

              <!-- Notifikasi Gateway -->
              <div class="section-header mb-2">
                <v-icon color="#1f7a57" class="mr-2" small>mdi-bell-outline</v-icon>
                <span class="section-header__text">Notifikasi Sistem Gateway</span>
              </div>
              <p class="appinfo-hint mb-4">
                Digunakan untuk mengirim info open ticket baru dan reset kata sandi ke nomor admin.
                Sesi pengirim harus sudah terhubung di menu Pengaturan.
              </p>

              <v-row dense>
                <v-col cols="12" md="6">
                  <v-select
                    label="Sesi WA pengirim (gateway)"
                    color="#1f7a57"
                    item-color="#1f7a57"
                    v-model="record.app_gateway_phone"
                    :items="gatewaySessions"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    clearable
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-cellphone-wireless"
                    placeholder="Pilih sesi terhubung"
                    :loading="loadingSessions"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Nomor WA admin (tujuan)"
                    color="#1f7a57"
                    v-model="record.app_notify_wa"
                    dense
                    outlined
                    hide-details="auto"
                    class="appinfo-field"
                    prepend-inner-icon="mdi-account-tie-voice"
                    placeholder="628xxxxxxxxxx"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider class="appinfo-divider"></v-divider>
          <v-card-actions class="pa-4 appinfo-actions">
            <v-spacer></v-spacer>
            <v-btn
              outlined
              class="appinfo-btn-outline mr-2"
              :disabled="saving"
              @click="fetchRecord"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Muat Ulang
            </v-btn>
            <v-btn
              class="appinfo-btn-primary"
              dark
              :loading="saving"
              @click="fetchUpdate"
            >
              <v-icon left small>mdi-content-save</v-icon>
              Simpan Perubahan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "app-info",
  data: () => ({
    saving: false,
    loadingSessions: false,
    gatewaySessions: [],
    foto: "/",
    bg: "/",
    bg_nav: "/image/bg-nav.jpep",
    record: {},
    colors: [
      { value: "red", text: "Red" },
      { value: "pink", text: "Pink" },
      { value: "purple", text: "Purple" },
      { value: "deep purple", text: "Deep Purple" },
      { value: "indigo", text: "Indigo" },
      { value: "light blue", text: "Light Blue" },
      { value: "cyan", text: "Cyan" },
      { value: "teal", text: "Teal" },
      { value: "green", text: "Green" },
      { value: "light green", text: "Light Green" },
      { value: "lemon", text: "Lemon" },
      { value: "yellow", text: "Yellow" },
      { value: "amber", text: "Amber" },
      { value: "orange", text: "Orange" },
      { value: "deep orange", text: "Deep Orange" },
      { value: "brown", text: "Brown" },
      { value: "blue grey", text: "Blue Grey" },
      { value: "grey", text: "Grey" },
    ],
    themes: [
      { value: "light", text: "Light" },
      { value: "dark", text: "Dark" },
    ],
  }),

  computed: {
    ...mapState([
      "theme",
      "http",
      "device",
      "records",
      "loading",
      "event",
      "snackbar",
    ]),
    bgStyle() {
      if (this.bg && this.bg !== "/") {
        return { backgroundImage: `url(${this.bg})` };
      }
      return {};
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/profil-sekolah",
      pagination: false,
      title: "INFORMASI APLIKASI",
      subtitle: "Berikut Data Informasi Aplikasi Anda",
      breadcrumbs: [
        {
          text: "Master Data",
          disabled: false,
          href: "",
        },
        {
          text: "Informasi Aplikasi",
          disabled: false,
          href: "",
        },
      ],
    });
    this.fetchRecord();
    this.fetchGatewaySessions();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "assignFileBrowse",
      "getUserInfo",
      "fetchRecords",
      "setTheme",
      "getAppInfo",
    ]),

    async fetchGatewaySessions() {
      this.loadingSessions = true;
      try {
        const { data } = await this.http.get(
          "api/superadmin/master-data/pengaturan"
        );
        const rows = Array.isArray(data) ? data : [];
        this.gatewaySessions = rows
          .filter((r) => r.phone_number)
          .map((r) => ({
            value: String(r.phone_number),
            text: `${r.name || "Sesi"} · ${r.phone_number}${
              r.status && r.status.text ? ` (${r.status.text})` : ""
            }`,
          }));
      } catch (e) {
        this.gatewaySessions = [];
      } finally {
        this.loadingSessions = false;
      }
    },

    fetchRecord: async function () {
      let { data } = await this.http.get("api/superadmin/master-data/app-info");

      this.record = data;
      this.foto = data.app_logo_path;
      this.bg = data.app_background_path;
      this.bg_nav = data.app_nav_path;
      this.getAppInfo();
    },
    fetchUpdate: async function () {
      this.saving = true;
      try {
        let {
          data: { status, message, data },
        } = await this.http.put(
          "api/superadmin/master-data/app-info/" + this.record.id,
          this.record
        );

        if (!status) {
          this.snackbar.color = "red";
          this.snackbar.text = message;
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = this.theme.color;
        this.snackbar.text = message;
        this.snackbar.state = true;

        this.record = data;
        this.fetchRecord();
        this.getUserInfo();
      } catch (error) {
        let messages = error.response.data.errors[0].message;
        this.snackbar.color = "red";
        this.snackbar.text = messages;
        this.snackbar.state = true;
      } finally {
        this.saving = false;
      }
    },

    editBackground: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          this.bg = response.path;
          this.record.app_background = response.name;
        },
      });
    },

    editSidebar: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          this.bg_nav = response.path;
          this.record.app_nav = response.name;
        },
      });
    },

    uploadFoto: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png", ".svg"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          setTimeout(() => {
            this.foto = response.path;
            this.record.app_logo = response.name;
          }, 1000);
        },
      });
    },
  },
};
</script>

<style scoped>
.appinfo-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
  background: transparent;
}

.appinfo-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.appinfo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.appinfo-header__title {
  display: flex;
  align-items: center;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 1rem;
}

.appinfo-header__title .v-icon {
  color: var(--gw-mint) !important;
}

.appinfo-header__save {
  color: #f4fbf7 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

.appinfo-header__save:hover {
  background: rgba(143, 214, 181, 0.18) !important;
}

.section-header {
  display: flex;
  align-items: center;
}

.section-header__text {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--gw-ink);
}

.appinfo-hint {
  margin: 0;
  font-size: 0.82rem;
  color: #5d7268;
  line-height: 1.45;
  max-width: 42rem;
}

.appinfo-divider {
  border-color: var(--gw-line) !important;
}

.asset-preview {
  background: var(--gw-fog);
}

.asset-background {
  position: relative;
  min-height: 220px;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
}

.asset-background__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(11, 61, 46, 0.2) 0%,
    rgba(10, 51, 39, 0.72) 100%
  );
}

.asset-background__actions {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
}

.asset-btn {
  color: #f4fbf7 !important;
  border-color: rgba(143, 214, 181, 0.45) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  background: rgba(255, 255, 255, 0.06) !important;
}

.asset-btn:hover {
  background: rgba(143, 214, 181, 0.18) !important;
}

.asset-content {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: flex-end;
  gap: 16px;
  padding: 20px;
}

.asset-logo {
  position: relative;
  flex-shrink: 0;
  width: 104px;
  height: 104px;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}

.asset-logo:hover {
  transform: translateY(-2px);
}

.asset-logo__hint {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(11, 61, 46, 0.72);
  color: #f4fbf7;
  font-size: 11px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.asset-logo:hover .asset-logo__hint {
  opacity: 1;
}

.asset-meta {
  flex: 1;
  min-width: 0;
  padding-bottom: 8px;
  color: #f4fbf7;
}

.asset-meta__name {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.15rem;
  line-height: 1.25;
}

.asset-meta__sub {
  margin-top: 0.2rem;
  font-size: 0.8rem;
  color: rgba(244, 251, 247, 0.7);
}

.asset-nav {
  position: relative;
  flex-shrink: 0;
  width: 76px;
  height: 110px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(143, 214, 181, 0.35);
  transition: transform 0.2s ease;
}

.asset-nav:hover {
  transform: translateY(-2px);
}

.asset-nav__panel {
  height: 100%;
  padding: 10px 8px;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.asset-nav__brand-mark {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  color: #0b3d2e;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.asset-nav__lines {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.asset-nav__lines span {
  display: block;
  height: 8px;
  border-radius: 6px;
  background: rgba(143, 214, 181, 0.22);
}

.asset-nav__lines span:nth-child(2) {
  width: 70%;
}

.asset-nav__lines span:nth-child(3) {
  width: 85%;
}

.asset-nav__hint {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: rgba(11, 61, 46, 0.72);
  color: #f4fbf7;
  font-size: 10px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.asset-nav:hover .asset-nav__hint {
  opacity: 1;
}

.color-swatch {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
}

.appinfo-actions {
  background: var(--gw-paper);
}

.appinfo-btn-outline {
  color: var(--gw-forest) !important;
  border-color: var(--gw-line) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

.appinfo-btn-outline:hover {
  background: var(--gw-fog) !important;
  border-color: var(--gw-mint) !important;
}

.appinfo-btn-primary {
  background: linear-gradient(145deg, #1f7a57, #0d4a36) !important;
  color: #f4fbf7 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  box-shadow: 0 6px 16px rgba(13, 74, 54, 0.28) !important;
}

.appinfo-btn-primary:hover {
  background: linear-gradient(145deg, #259368, #0f5c45) !important;
}

.appinfo-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.appinfo-field >>> .v-icon {
  color: var(--gw-leaf) !important;
}

@media (max-width: 600px) {
  .appinfo-header {
    padding: 0.85rem 1rem;
  }

  .asset-background {
    min-height: 200px;
  }

  .asset-content {
    flex-wrap: wrap;
    padding: 16px;
  }

  .asset-meta {
    order: 3;
    flex-basis: 100%;
    padding-bottom: 0;
  }

  .asset-logo {
    width: 88px;
    height: 88px;
  }

  .asset-nav {
    width: 64px;
    height: 96px;
  }
}
</style>
